export default {
    duplicatable: false
}
